import { useUploadMediaMutation } from "@/redux/services/media/media.api";
import { Media } from "@/redux/services/media/media.type";
import { logger } from "@/services/Logger";

export const useUploadMedia = () => {
  const [uploadMediaMutation] = useUploadMediaMutation();

  const uploadMedia = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await uploadMediaMutation(formData);
      if ("data" in response) {
        return response.data as Media;
      } else if ("error" in response) {
        logger.error("useUploadMedia", "Upload Error:", response.error);
        return null;
      }
    } catch (error) {
      logger.error("useUploadMedia", "Upload failed:", error);
      return null;
    }
  };

  return { uploadMedia };
};
